import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpParams, HttpHeaders, HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { IFLInnovacio, IFLSotware } from '../dialog/innovacio/innovacio.interfaces';
import { APIURLConstantsService } from '../services/api-url-service/apiurlconstants.service';

@Injectable()
export class ManageInnovaService {

  private options: {
    headers?: HttpHeaders,
    observe?: 'body',
    params?: HttpParams,
    reportProgress?: boolean,
    responseType: any,
    withCredentials?: boolean
  };

  private _API_BASE_URL: string = environment['API_URL'];

  public get(innovaCodi: string): Observable<{innova: IFLInnovacio, soft: IFLSotware}> {
    return this.authHttp.get<any>(this._API_BASE_URL + 'innova/' + innovaCodi)
      .pipe(map(response => response || []));
  }

  public update(innovaCodi: string, payload: {inno: IFLInnovacio, soft: IFLSotware}): Observable<IFLInnovacio> {
    return this.authHttp.put<any>(this._API_BASE_URL + 'innova/' + innovaCodi, payload)
      .pipe(map(response => response || []));
  }

  public destroy(innovaCodi: string): Observable<IFLInnovacio> {
    return this.authHttp.delete<any>(this._API_BASE_URL + 'innova/' + innovaCodi)
      .pipe(map(response => response || []));
  }

  public getAutocomplete(id: string): Observable<Array<{value: string, text: string}>> {
   this.options = {
     headers: new HttpHeaders().set('Content-Type', 'application/json'), responseType: 'json'
   }
   return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + 'autocomplete/' + id, this.options)
   .pipe(map(response => { return response || [] }));
   }
  constructor(private authHttp: HttpClient) { }

}
